import { Button } from "@fluentui/react-components";
import { useViewPreferences } from "../contexts/ViewPreferencesContext";
import "./ViewControls.css";

export function ViewControls() {
    const { view, setView } = useViewPreferences();
    return <div className="view-controls" role="group" aria-label="Page view">
        <span>View</span>
        {["standard", "compact"].map(value => <Button key={value} size="small"
            appearance={view === value ? "primary" : "secondary"} aria-pressed={view === value}
            onClick={() => setView(value)}>{value === "compact" ? "Compact list" : "Standard"}</Button>)}
    </div>;
}
